import { useQuery } from "@tanstack/react-query";

import { getIntelligenceDashboard } from "@/api/intelligence";

export function useIntelligenceDashboard(
  churchId?: string,
) {
  return useQuery({
    queryKey: ["intelligence-dashboard", churchId],
    enabled: !!churchId,
    queryFn: () => getIntelligenceDashboard(churchId!),
  });
}